import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import {
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA
} from '@angular/material/dialog';
import {
  BeneficiaryCardEnum,
  EntityEnum,
  IApprobationFormData,
  IContractInput} from 'src/app/models/contract';
import { IBeneficiaryFormGroup, IGenericContract, IGenericContractFormGroup } from 'src/app/models/generic';
import { ITab } from 'src/app/models/tabs';
import { ApiContractService } from 'src/app/services/api/api-contract.service';
import { ApiVerificationService } from 'src/app/services/api/api-verification.service';
import { Inputs } from 'src/app/shared/utils/base';

@Component({
  selector: 'app-aprovacao-modal-form',
  templateUrl: './aprovacao-modal-form.component.html',
  styleUrls: ['./aprovacao-modal-form.component.scss']
})
export class AprovacaoModalFormComponent implements OnInit {
  tabs: ITab[] = [];
  currentTab!: number;
  clickTrash: boolean = false;
  currentVersion = false;

  _form!: FormGroup<IGenericContractFormGroup>;
  BeneficiaryCardEnum = BeneficiaryCardEnum;
  contractData!: IGenericContract;
  EntityEnum = EntityEnum;

  editableFields: { [key: string]: string[] } = {
    Contract: [],
    Beneficiary: []
  };

  inputControlsDetails: IContractInput[] = Inputs[
    'detalhes'
  ] as IContractInput[];
  inputControlsFinancy: IContractInput[] = Inputs[
    'financiamento'
  ] as IContractInput[];
  invoiceBeneficiariesControls = Inputs['beneficiarioParceiro'] as IContractInput[];
  transferBeneficiariesControls = Inputs['beneficiarioSubsidiaria'] as IContractInput[];

  constructor(
    private _dialogRef: MatDialogRef<AprovacaoModalFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IApprobationFormData,
    private _verificationService: ApiVerificationService,
    private _contractService: ApiContractService
  ) { }

  ngOnInit(): void {
    this.generateTabs();
    this.currentTab = Number(this.data.currentTab);
    this.currentVersion = Boolean(this.data.currentVersion);
    this.initalizeForm();
  }

  generateTabs(): void {
    this.tabs = [
      { title: 'Nova versão', id: 1 },
      { title: 'Antiga versão', id: 2 }
    ];
  }

  initalizeForm(): void {
    this._contractService.initializeForm(this.data.id ?? '', '', '', true, this.currentVersion)
      .subscribe({
        next: (response) => {
          this._form = response;
          this.contractData = this._contractService.contractData;
        },
        error: (err) => this.handleFormError()
      });
  }

  handleFormError(): void {
    this._dialogRef.close();
  }

  get Beneficiaries() {
    return this._form.controls['Beneficiaries'] as FormArray<
      FormGroup<IBeneficiaryFormGroup>
    >;
  }

  changeTab(tab: number): void {
    this.currentTab = tab + 1;

    this.currentVersion = this.currentTab === 1 ? false : true;

    this.initalizeForm();
  }

  // getContractByVersion(current: boolean): void {
  //   this._verificationService
  //     .getContractById(
  //       String(this._contractService.contractData.ContractId),
  //       this.currentVersion
  //     )
  //     .subscribe((res) => {
  //       this.form.patchValue(res.Data);
  //       this._contractService.patchForm(res.Data);
  //     });
  // }

  close(action: boolean): void {
    let data = null;

    if (action) {
      // data = this.form;
    }

    this._dialogRef.close(data);
  }
}
